import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';


const Login = ({ location, translate }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const validateParams = () => {
    return !!(parameters.client_id && parameters.redirect_uri && parameters.response_type);
  };

  useEffect(() => {
    document.title = 'STAR TV | Ingresar';
  }, []);

  return (
    <Container fluid={true} className="startv-body">
      <Row>
        <Col className='my-auto'>
          {validateParams() ? (
            <LoginForm
              api={api}
              location={location}
            />
          ) : (
            <RequestLoginErrorMessage
              onlyMessage={true}
              message={translate('RequestLoginErrorMessage')}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
